import axios from 'axios';
import { CostCenterDutyHourType } from 'components/admin-portal/Settings/AbsenceImport/types';

import { ROSTER_DUTY_HOUR_TYPES } from 'RestAPIs/endpoints';

export interface GetRosterDutyHourTypesOptions {
  startDate: string;
  endDate: string;
}

export const getRosterDutyHourTypes = ({
  startDate,
  endDate
}: GetRosterDutyHourTypesOptions) =>
  axios.get<CostCenterDutyHourType[]>(ROSTER_DUTY_HOUR_TYPES, {
    params: {
      startDate,
      endDate
    }
  });
